module.exports = __webpack_public_path__ + "static/media/music.96cd42e1.jpg";